import {useFormik} from "formik";
import * as Yup from "yup";
import {persianToEnglish} from "../../tools/helpers";
import React, {useContext, useState} from "react";
import Button from "../Button";
import Api from "../../tools/service";
import OriginalityDeviceContext from "../../tools/contexts/originalityDevice/originalityDeviceContext";
import ProgressLoading from "../loading/ProgressLoading";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import SuccessStageModal from "../modals/SuccessStageModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";

const InitConfirm = () => {
    const originalityDeviceContext = useContext(OriginalityDeviceContext)
    const [loading, setLoading] = useState(false)
    const handleSubmit = (values) => {
        setLoading(true);
        Api.put(REQUEST_URLS.ORIGINALITY_DEVICE.INIT_CONFIRM, {
            IMEI: persianToEnglish(values.IMEI),
            NationalId: persianToEnglish(values.NationalId),
            pid: originalityDeviceContext.pid
        }, {
            headers: {
                "Authorization": `Bearer ${originalityDeviceContext.token}`
            }
        }).then((response => {
            const {data, status, message, hasError} = response;
            if (hasError) {
                setLoading(false)
                originalityDeviceContext.handleError({
                    status,
                    message,
                    data,
                    pid: originalityDeviceContext.pid,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            onConfirm: () => {

                            },
                            confirmButtonText: '',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'بستن',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                Reoverlay.hideModal();

                            }
                        })
                    }
                })
            } else {
                originalityDeviceContext.handleGetProcess(originalityDeviceContext.pid);
            }
        })).catch(e => {

        })

    }
    const handleShowGuide = () => {
        Reoverlay.showModal(SuccessStageModal, {
            title: '',
            subTitle: 'راهنما',

            showIcon: false,
            showTitle: false,

            theme: "green",
            description: <span>برای پیدا کردن IMEI تلفن همراه خود از کد <strong className="text-lg text-blue-500 "
                                                                                dir="ltr">*#06#</strong> استفاده کنید</span>,
            closeButtonText: 'بستن',
            nextStepText: 'بستن',
            onConfirm: () => {
                Reoverlay.hideModal();
            }
        })
    }

    const ValidationSchema = Yup.object().shape({

        IMEI: Yup.string().required('کد IMEI الزامیست.').test(
            'is-imei',
            'کد IMEI معتبر نمی باشد.',
            (value) => /^\d{15}$/.test(persianToEnglish(value))
        ),
        NationalId: Yup.string()
            .min(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
            .max(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
            .required('  کد ملی را وارد کنید.')
            .test("isNumber", " کد ملی عددی می باشد", (value) => {
                if (!value) {
                    return false;
                }
                return !isNaN(persianToEnglish(value));
            }),

    });
    const formik = useFormik({
        initialValues: {
            IMEI: '',
            NationalId:'',

        },
        validationSchema: ValidationSchema,
        onSubmit: handleSubmit,
    });
    if (loading) {
        return <ProgressLoading showProgress={false} type="HamtaInquiry" duration={30}
                                text="در حال ارسال اطلاعات تلفن همراه" theme="green"/>
    }
    return <div className="flex  flex-col items-center  justify-center">
        <h1 className="text-4xl mt-10 text-center ">ونیفای</h1>
        <div className="w-11/12 lg:w-4/12 mx-auto bg-white mt-5   p-5 rounded-lg ">
            <div className="border-b flex flex-col items-center  my-3 pb-5 ">
                <h1 className="mb-1 font-bold text-lg ">استعلام مدل گوشی</h1>
                <p className="text-center text-sm px-3 "> با این استعلام مدل تلفن همراه بررسی و نتیجه آن روی آگهی شما
                    قرار میگیرد</p>
            </div>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex justify-between">
                    <label className="text-sm mb-1 " htmlFor="IMEI">کد IMEI </label>
                    <span onClick={handleShowGuide} className="text-blue-500 text-sm ">راهنما</span>
                </div>
                <input dir="rtl" onChange={formik.handleChange} value={formik.values.IMEI} type="tel"
                       className="w-full mt-1  bg-gray-100  text-right rounded-xl p-3"
                       placeholder="کد IMEI را وارد کنید"
                       name="IMEI"/>
                {formik.errors.IMEI && formik.touched.IMEI ? (
                    <p className="text-red-400 text-sm font-light mt-1 ">{formik.errors.IMEI}</p>
                ) : null}
                <div className="flex justify-between">
                    <label className="text-sm mb-1 " htmlFor="NationalId">کد ملی </label>

                </div>
                <input dir="ltr" onChange={formik.handleChange} value={formik.values.NationalId} type="tel"
                       className="w-full mt-1  bg-gray-100  text-right rounded-xl p-3"
                       placeholder="کد ملی  را وارد کنید"
                       name="NationalId"/>
                {formik.errors.NationalId && formik.touched.NationalId ? (
                    <p className="text-red-400 text-sm font-light mt-1 ">{formik.errors.NationalId}</p>
                ) : null}
                <Button className="text-sm mt-3 w-full rounded-lg " theme="green" type={"submit"}>مرحله بعد</Button>
            </form>
        </div>

    </div>
}

export default InitConfirm;